export default "__VITE_PUBLIC_ASSET__c2157c1a__"